import { FC, RefObject, useContext, useEffect, useRef } from "react";

//SimpleBar
//import SimpleBar from "simplebar-react"; delete-uninstall
//import { Transition } from 'react-transition-group'; delete-uninstall
import { Link } from "react-router-dom";
import FilterList from "../Accordion/FilterList";
import styles from "./FilterRightBar.module.scss"
import { FilterContext } from "../FilterContext";
import { useTranslation } from "react-i18next";
import { Button, Col } from "reactstrap";
import { MisterIcon } from "@rtel/mister-icons";

const duration = 300;

/*const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  backgroundColor: 'red',
  opacity: 0,
}*/

const defaultStyle = {
  height: '100%',
  position: 'fixed',
  zIndex: '9999',
  top: 0,
  right: 0,
  transition: 'all .5s ease',
  width: 0,
}




const FilterRightBar: FC = () => {
  const currentFilterContext = useContext(FilterContext);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  // Update the width of the sidebar element when the sidebar is open
  useEffect(() => {
    if (sidebarRef.current) {
      sidebarRef.current.style.width = currentFilterContext.isSliderFilterOpen ? '500px' : '0';
    }
  }, [currentFilterContext.isSliderFilterOpen]);

  return (
    <>
      {currentFilterContext.isSliderFilterOpen && 
      <div className={styles.sidebar} ref={sidebarRef}>
          <div className={styles.rightBarFilterContainer}>
              <div className={`${styles.rightbarTitle} d-flex align-items-center p-3`}>
                <div className="m-0 me-2 w-100 h2">
                  {t("Filters")} 
                  <div className={styles.activeFiltersNumberContainer}>
                    <span className={styles.activeFiltersNumber}>
                      {currentFilterContext.numberOfActiveFilters}
                    </span>
                  </div>
                </div>
                <Link
                    to="#"
                    onClick={currentFilterContext.toggleFilterSidebar}
                    className={`right-bar-toggle ms-auto ${styles.closeButtonContainer}`}
                >
                    <MisterIcon name="XClose" size="lg" className={styles.closeButton} />
                </Link>
              </div>

              <hr className="m-0" />
        
              { currentFilterContext.filterData && 
                <FilterList items={currentFilterContext.filterData} />
              }
              <Col 
                xs={12}
                className={`position-fixed bottom-0 w-100 bg-light d-block ${styles.rightBarActionContainer}`}
              >
                <Button onClick={currentFilterContext.postFilterData}> { t("Search") } </Button>
                {currentFilterContext.numberOfActiveFilters > 0 && 
                  <Button className="ms-3" onClick={currentFilterContext.clearAllFilters}> { t("Clear") } </Button>
                }                
              </Col>
          </div>
        </div>       
}     
    </>
  );
};

export default FilterRightBar;



